import React from 'react';

function UserAgreement() {
    return (
        <div className="user-agreement">
            <h1><strong>User Agreement</strong></h1>
            <p>
                This User Agreement governs your use of the Digital Wardrobe platform and its services. By accessing or using the platform, you agree to be bound by the terms and conditions outlined in this agreement. If you do not agree, you may not use our services.
            </p>

            <h3><strong>1. Acceptance of the Agreement</strong></h3>
            <p>
                By creating an account and using the Digital Wardrobe platform, you acknowledge that you have read, understood, and agree to comply with this agreement and any additional terms applicable to specific services or features. This agreement may be updated from time to time, and continued use of the platform indicates acceptance of the revised terms.
            </p>

            <h3><strong>2. Eligibility</strong></h3>
            <p>
                You must be at least 18 years old, or the legal age of majority in your jurisdiction, to create an account and use the platform. By creating an account, you represent and warrant that you meet these requirements and that the information you provide is accurate and complete.
            </p>

            <h3><strong>3. Account Security</strong></h3>
            <p>
                You are responsible for maintaining the confidentiality of your account credentials, including your e-mail and password. You agree not to share your account information with others and to notify Digital Wardrobe immediately of any unauthorized use of your account.
            </p>

            <h3><strong>4. User Conduct</strong></h3>
            <p>
                You agree to use the platform in a lawful manner and not engage in any activity that is harmful, abusive, or in violation of the rights of others. Prohibited conduct includes, but is not limited to, the following:
            </p>
            <p><li>Using the platform to harass, threaten, or defraud others.</li>
                <li>Uploading content that violates the intellectual property rights of others.</li>
                <li>Using automated systems to scrape, collect, or access platform data without authorization.</li>
                <li>Interfering with the normal functioning of the platform.</li></p>

            <h3><strong>5. User-Generated Content</strong></h3>
            <p>
                By submitting or sharing content (such as clothing images, outfits, occasions or travel lists) on the platform, you grant Digital Wardrobe a non-exclusive, royalty-free, perpetual license to use, display, modify, and distribute your content for the purpose of providing and improving the platform’s services. You represent that you own or have the rights to share the content and that it does not violate the rights of others.
            </p>

            <h3><strong>6. Privacy and Data Security</strong></h3>
            <p>
                Your use of the platform is governed by our <a href="/privacy-policy">Privacy Policy</a>. By using the platform, you consent to the collection, use, and sharing of your data as described in the Privacy Policy. You are responsible for keeping your account information up to date and for maintaining the security of your account.
            </p>

            <h3><strong>7. Termination</strong></h3>
            <p>
                Digital Wardrobe reserves the right to suspend or terminate your account at its discretion, including but not limited to instances of fraudulent activity, violation of this Agreement, or any misuse of the platform. Termination may result in the loss of access to your account and any associated data.
            </p>

            <h3><strong>8. Limitation of Liability</strong></h3>
            <p>
                Digital Wardrobe is not liable for any direct, indirect, incidental, special, or consequential damages arising from your use of the platform or the inability to use the platform, including unauthorized access to your data. The platform is provided "as is" without warranty of any kind.
            </p>

            <h3><strong>9. Intellectual Property</strong></h3>
            <p>
                All content and intellectual property related to the Digital Wardrobe platform, including but not limited to text, graphics, logos, and software, are the property of Digital Wardrobe or its licensors and are protected by copyright, trademark, and other intellectual property laws. You may not use, copy, or distribute any content from the platform without our prior written consent.
            </p>

            <h3><strong>10. Governing Law</strong></h3>
            <p>
                This Agreement is governed by the laws of your jurisdiction, without regard to its conflict of law principles. Any disputes arising from this agreement or your use of the platform will be resolved in the courts of your jurisdiction.
            </p>

            <h3><strong>11. Changes to the Agreement</strong></h3>
            <p>
                Digital Wardrobe reserves the right to modify this Agreement at any time. We will notify users of any changes by posting the revised Agreement on the platform. It is your responsibility to review the Agreement periodically. Continued use of the platform constitutes acceptance of the updated terms.
            </p>

            <h3><strong>12. Contact Information</strong></h3>
            <p>
                If you have any questions or concerns about this User Agreement, please contact us at <strong>digitalwardrobe@info.com</strong>.
            </p>
        </div>
    );
}

export default UserAgreement;
